module.exports = __webpack_public_path__ + "img/login.005a192.svg";